import { amplifyProxy } from '@/services/directApi'

export default {
  namespaced: true,
  state: {
    landlords: '',
    loading: false,
    error: null
  },
  mutations: {
    SET_LANDLORDS(state, data) {
      state.landlords = data
    },
    SET_LOADING(state, value) {
      state.loading = value
    },
    SET_ERROR(state, error) {
      state.error = error
    }
  },
  actions: {
    async getLandlordsCount({ commit, dispatch }) {
      commit('SET_LOADING', true)
      commit('SET_ERROR', null)

      try {
        const [bankless, emailless, owing, tenPercentDiff] = await Promise.all([
          dispatch('getLandlordsBankless'),
          dispatch('getLandlordsEmailless'),
          dispatch('getLandlordsOwing'),
          dispatch('getLandlordsTenPercentBalance')
        ])

        commit('SET_LANDLORDS', {
          bankless: bankless.data,
          emailless: emailless.data,
          owing: owing.data,
          tenPercentDiff: tenPercentDiff.data
        })

        return {
          bankless: bankless.data,
          emailless: emailless.data,
          owing: owing.data,
          tenPercentDiff: tenPercentDiff.data
        }
      } catch (error) {
        commit('SET_ERROR', error.message)
        throw error
      } finally {
        commit('SET_LOADING', false)
      }
    },

    async getLandlordsBankless({ rootState }) {
      const endpoint = `/${rootState.user.ClientName}/landlords/bankless/count`
      const options = {
        headers: {
          token: rootState.user.LoginToken,

        },
        queryStringParameters: {
          branchID: rootState.branchID
        }
      }

      return amplifyProxy.get(endpoint, options)
    },

    async getLandlordsEmailless({ rootState }) {
      const endpoint = `/${rootState.user.ClientName}/landlords/emailless/count`
      const options = {
        headers: {
          token: rootState.user.LoginToken,

        },
        queryStringParameters: {
          branchID: rootState.branchID
        }
      }

      return amplifyProxy.get(endpoint, options)
    },

    async getLandlordsOwing({ rootState }) {
      const endpoint = `/${rootState.user.ClientName}/landlords/owing/count`
      const options = {
        headers: {
          token: rootState.user.LoginToken,

        },
        queryStringParameters: {
          branchID: rootState.branchID
        }
      }

      return amplifyProxy.get(endpoint, options)
    },

    async getLandlordsTenPercentBalance({ rootState }) {
      const endpoint = `/${rootState.user.ClientName}/landlords/tenPercentBalanceDifference/count`
      const options = {
        headers: {
          token: rootState.user.LoginToken,

        },
        queryStringParameters: {
          branchID: rootState.branchID
        }
      }

      return amplifyProxy.get(endpoint, options)
    }
  }
}